namespace $.$$ {

	export class $shm_hitalama_footer extends $.$shm_hitalama_footer {

		@ $mol_mem
		logo_uri() {
			const uri = $shm_hitalama_ghpages_fix_link( super.logo_uri() )
			if( this.$.$mol_lights() ) return uri.replace( 'light', 'dark' )
			return uri
		}

	}

}
